define('v3/Pages/Settings/Components/SortingPreferences/SortingPreferences.Component',[
	'knockout',
	'lodash',
	'v3/Common/Services/frontend/Frontend.Service',
	'text!v3/Pages/Settings/Components/SortingPreferences/SortingPreferences.Component.html',
	'env',
	'v3/Common/Services/pupilSortService',
	'knockout-validation',
	'knockout-track-changes',
	'v3/Common/Bindings/SvgIcon.Binding',
	'domReady!'
],
function (ko, _, frontend, htmlString, env, pupilSortService) {
	function SortingPreferences () {
		var self = this;
		var classId = env.userInfo.classId;

		self.save = function () {
			pupilSortService.setSortField(classId, self.sortOn());
			self.modal.close();
			frontend.notification.success({
				text: Strings.SortingPreferencesSavedSuccesfully
			});
		};

		self.cancel = function () {
			self.modal.close();
		};

		self.sortOn = ko.observable(getPupilSortingPreference());

		function getPupilSortingPreference () {
			return pupilSortService.getSortField(classId);
		}
	};

	return { viewModel: SortingPreferences, template: htmlString };
});
